import { cn } from "@/lib/utils"

// Bordered thumbnail for uploaded logos/photos on admin detail pages.
// Uploaded images are typically designed for light backgrounds (often with
// solid white fills), so in dark mode the image is dimmed rather than left
// glowing at full brightness.
export default function LogoPreview({
  src,
  alt,
  className,
}: {
  src: string
  alt: string
  className?: string
}) {
  return (
    <div
      className={cn(
        "bg-muted dark:bg-muted/50 flex h-16 max-w-60 items-center justify-center border p-2",
        className,
      )}
    >
      <img
        src={src}
        alt={alt}
        className="h-full w-full object-contain dark:opacity-80"
      />
    </div>
  )
}
